module.exports = __webpack_public_path__ + "weathericons-regular-webfont.2ca3df0981116e195ebc.ttf";


//////////////////
// WEBPACK FOOTER
// C:/Users/thana/Documents/sdc-nida-front_2024/backoffice/node_modules/weather-icons/font/weathericons-regular-webfont.ttf
// module id = ../../../../weather-icons/font/weathericons-regular-webfont.ttf
// module chunks = styles